import {
  LOADING_BANNERS,
  LOADED_BANNERS,
  CREATE_BANNERS,
  UPDATE_BANNERS,
  UPDATE_URL,
  UPDATE_LINK_TYPE,
  UPDATE_BANNER_PROMO,
  SAVING_BANNERS,
  SAVED_BANNERS,
  CLEAN_PROPS,
  DELETE_BANNERS
} from '../actions/partnerBanner';

const initialState = {
  bannerList: []
};

export default function (state = initialState, action) {
  let {banners, image, key, url, linkType, promo} = action;

  switch (action.type) {

    case LOADING_BANNERS:
      return Object.assign({}, state, {
        loading: true
      });

    case LOADED_BANNERS:
      return Object.assign({}, state, {
        loading: false,
        bannerList: Array.concat(banners, [])
      });

    case CREATE_BANNERS:
      return Object.assign({}, state, {
        bannerList: Array.concat(state.bannerList, [])
      });

    case UPDATE_BANNERS:
      if (state.bannerList[key]._image) {
        state.bannerList[key]._image = image;
      } else {
        state.bannerList[key].photo.small = image.url;
        state.bannerList[key].photo.original = image.url;
      }
      return Object.assign({}, state, {
        bannerList: Array.concat(state.bannerList, [])
      });

    case UPDATE_URL:
      state.bannerList[key].reference.uri = url;
      return Object.assign({}, state, {
        bannerList: Array.concat(state.bannerList, [])
      });

    case UPDATE_LINK_TYPE:
      state.bannerList[key].reference.type = linkType;
      state.bannerList[key].reference.uri = '';
      return Object.assign({}, state, {
        bannerList: Array.concat(state.bannerList, [])
      });

    case UPDATE_BANNER_PROMO:
      state.bannerList[key].promo = promo;
      state.bannerList[key].reference.uri = promo.id;
      return Object.assign({}, state, {
        bannerList: Array.concat(state.bannerList, [])
      });

    case SAVING_BANNERS:
      return Object.assign({}, state, {
        loading: true
      });

    case SAVED_BANNERS:
      return Object.assign({}, state, {
        loading: false
      });

    case CLEAN_PROPS:
      return Object.assign({}, state, {
        bannerList: []
      });

    case DELETE_BANNERS:
      state.bannerList.splice(key, 1);
      return Object.assign({}, state, {
        bannerList: Array.concat(state.bannerList, [])
      });

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/banner.js